import React from 'react';
import { CContainer, CBreadcrumb, CBreadcrumbItem, CCard, 
  CCardHeader, CCardBody, CRow, CCol } from '@coreui/react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from '../../hooks/useTranslation';
import CustomerInputs from '../../components/CustomerInputs/CustomerInputs';
import { updateCustomerRequest } from '../../store/customer/customerActions';

const UpdateCustomer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const isLoading = useSelector(state => state.customerReducer.isLoading);
  const submitResponse = useSelector(state => state.customerReducer.updateCustomerData);
  const initialData = location.state?.customer || null;

  const handleSubmit = (data) => {
    dispatch(updateCustomerRequest({ ...data, navigate }));
  };

  const handleCancel = () => {
    navigate('/customers');
  };

  return (
    <CContainer>
      <CBreadcrumb className="mb-4">
        <CBreadcrumbItem href="#/customers" onClick={e => 
          { e.preventDefault(); handleCancel(); }}>{t('customers')}</CBreadcrumbItem>
        <CBreadcrumbItem active>{t('updateCustomer')}</CBreadcrumbItem>
      </CBreadcrumb>
      <CRow>
        <CCol xs={12}>
          <CCard>
            <CCardHeader><h4>{t('updateCustomer')}</h4></CCardHeader>
            <CCardBody>
              <CustomerInputs onSubmit={handleSubmit} 
              onCancel={handleCancel} isLoading={isLoading} 
              submitResponse={submitResponse} initialData={initialData} isEdit />
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  );
};

export default UpdateCustomer; 